export default {"src":"/_next/static/media/aparat-icon.0e714a20.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};